// extracted by mini-css-extract-plugin
export default {"videoPlayer":"VideoPlayerSingle_videoPlayer__e5lB4","largeCaptions":"VideoPlayerSingle_largeCaptions__ETtKT","btnPlay":"VideoPlayerSingle_btnPlay__tdiYT"};